<template>
  <div class="page flex-col">
    <div class="header flex-row">
      <BackButton
        :customClick="handleBackClick"
        class="back"
      />
      
      <Dropdown
        class="select_item"
        :options="academicOptions"
        placeholder="学年"
        @selection-change="handleYearSelection"
      />

      <Dropdown
        class="select_item"
        :options="classOptions"
        placeholder="班级"
        @selection-change="handleClassSelection"
      />
    </div>

    <div class="menu flex-row">
      <TeacherMenu />
    </div>

    <div class="container flex-row">
      <div class="left_box flex-col">
        <div class="course_name">{{ lessonName }}</div>
        <div class="left_table">
          <DataTable
            :headers="tableHeaders"
            :items="loopData"
            :idx="0"
            @item-click="handleItemClick"
          />
        </div>
      </div>
      <div class="right_box flex-col">
        <TaskTable
          :headers="taskHeaders"
          :items="taskData"
          show-pagination="true"
          total="1"
          @item-click="handleItemTaskClick"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"

import Dropdown from "@/components/teacher/Dropdown.vue"
import DataTable from "@/components/teacher/DataTable.vue"
import TaskTable from "@/components/teacher/TaskTable.vue"
import BackButton from "@/components/teacher/BackButton.vue"
import TeacherMenu from "@/components/teacher/TeacherMenu.vue"
import alovaInstance from "@/utils/alova"

const route = useRoute()
const router = useRouter()
const store = useStore()

const lessonName = ref("")
const academicOptions = ref([])
const classOptions = ref([])
const academicYear = ref("")
const classId = ref(-1)
const taskId = ref(-1)
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

const tableHeaders = [
  {
    key: "serial_no",
    label: "任务",
    style: "width: 5.5vw;",
    cellStyle: "width: 8.8vw;",
  },
  {
    key: "name",
    label: "任务名称",
    style: "width: 9.8vw;",
    cellStyle: "width: 14.5vw;text-align: left;margin-left: 2.4vw;",
  },
]

// const loopData = ref([
//   {
//     idx: 1,
//     taskName: "扫地"
//   },
// ])
const loopData = ref([])

const taskHeaders = [
  {
    key: "studentId",
    label: "ID",
    style: "width: 5vw;",
    cellStyle: "width: 9vw;text-align: center;",
  },
  {
    key: "name",
    label: "学生姓名",
    style: "width: 6.8vw;",
    cellStyle: "width: 7.5vw;text-align: left;margin-left: -1.2vw;",
  },
  {
    key: "attemptCount",
    label: "尝试次数",
    style: "width: 7.5vw;",
    cellStyle: "width: 4vw;text-align: center;",
  },
  {
    key: "score",
    label: "得分",
    style: "width: 7.5vw;",
    cellStyle: "width: 13vw;text-align: center;",
  },
  {
    key: "teacher_Score",
    label: "教师评分",
    style: "width: 7.5vw;",
    cellStyle: "width: 5vw;text-align: center;margin-left: -2.5vw;",
  },
  {
    key: "teacher_Comment",
    label: "教师评语",
    style: "width: 7.5vw;",
    cellStyle: "width: 8.8vw;text-align: left;margin-left: 3vw;",
  },
  {
    key: "statu",
    label: "记录",
    style: "width: 7.5vw;",
    cellStyle: "width: 2.6vw;height: 4.17vw;margin-left: 0.6vw;",
  },
]

// const taskData = ref([
//   {
//     id: 1,
//     studentName: "张三",
//     try: 0,
//     score: 10,
//     teacherScore: 10,
//     mark: '不错',
//     task: 2
//   },
// ])
const taskData = ref([])

onMounted(async () => {
  lessonName.value = store.getters.getLessonName
  try {
    const response = await alovaInstance.Post("/Class/GetAllAcademic")
    if (response.code === 1000) {
      academicOptions.value = response.data
    } else {
      alert("获取数据失败：" + response.message)
    }

    const allClass = await alovaInstance.Post("/Class/GetAllClass")
    if (allClass.code === 1000) {
      // console.log(allClass.data)
      classOptions.value = []
      for (let i = 0; i < allClass.data.length; i++) {
        classOptions.value.push({
          label: allClass.data[i].class_name,
          value: allClass.data[i].id,
        })
      }
    } else {
      alert("获取数据失败：" + allClass.message)
    }

    const allTask = await alovaInstance.Post("/Task/GetTaskDetailInfo", {
      lessonId: route.query.lessonId,
    })
    if (allTask.code === 1000) {
      let count = 0
      for (let i = 0; i < allTask.data.length; i++) {
        if (i == 0) {
          taskId.value = allTask.data[i].id
        }
        if (allTask.data[i].task_type == 0) {
          count++
        }
      }
      for (let i = 0; i < allTask.data.length; i++) {
        if (allTask.data[i].task_type == 1) {
          allTask.data[i].serial_no += count
        }
      }
      allTask.data.sort((a, b) => a.serial_no - b.serial_no)
      loopData.value = allTask.data
    } else {
      loopData.value = []
      alert("获取数据失败：" + allTask.message)
    }

    handleSelection()
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

const handleItemClick = async (item) => {
  taskId.value = item.id
  handleSelection()
}

const handleYearSelection = (year) => {
  // console.log("Selected year:", year)
  academicYear.value = year
  handleSelection()
}

const handleClassSelection = (value) => {
  // console.log("Selected class:", value)
  classId.value = value
  handleSelection()
}

const handleSelection = async () => {
  try {
    let lessonId = route.query.lessonId
    const response = await alovaInstance.Post("/Record/GetTaskRecords", {
      lessonId: lessonId,
      classId: classId.value,
      academicYear: academicYear.value,
      taskId: taskId.value,
      pageIndex: currentPage.value,
      pageSize: pageSize.value,
    })
    // console.log(response)
    if (
      response.code === 1000 &&
      response.data != null &&
      response.data.studentRecordList != null
    ) {
      taskData.value = response.data.studentRecordList
      total.value = response.data.total
    } else {
      taskData.value = []
      total.value = 0
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
}

const handleBackClick = () => {
  router.push({
    name: "TeacherCourse",
    query: {
      courseName: store.state.courseName,
      courseId: store.state.courseId,
    },
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.header {
  width: 80.6771vw;
  height: 3.4375vw;
  margin: 0.8854vw 0 0 1.5vw;
}

.back {
  margin-right: 1.5vw;
}

.select_item {
  margin: 0.05vw 0 0 1.25vw;
}

.menu {
  width: auto;
  height: auto;
  margin: 0 0 0 1.5vw;
}

.container {
  width: 80.68vw;
  height: auto;
  margin: 0 0 0 1.5vw;
}

.left_box {
  width: auto;
  margin-top: 1.15vw;
}

.course_name {
  width: 10vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.left_table {
  width: 26.6vw;
  height: auto;
  min-height: 32vw;
  background: #ffffff;
  border-radius: 0.83vw 0.83vw 0.83vw 0.83vw;
  margin-top: 1.15vw;
}

.right_box {
  width: 53.2vw;
  margin-left: 1.15vw;
  margin-top: 1.5vw;
}
</style>
